import React from 'react';
import { Typography, Card } from 'antd';
import { CreditCardOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const NotasCreditoPage = () => {
    return (
        <div style={{ padding: '24px' }}>
            <Card>
                <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                    <CreditCardOutlined style={{ fontSize: '64px', color: '#1890ff', marginBottom: '24px' }} />
                    <Title level={2}>Notas de Crédito</Title>
                    <Paragraph type="secondary">
                        Esta página está en desarrollo. Aquí podrás gestionar las notas de crédito.
                    </Paragraph>
                </div>
            </Card>
        </div>
    );
};

export default NotasCreditoPage;
